const pad2 = (n: number) => String(n).padStart(2, '0');

type DateInputType = 'date' | 'datetime-local';

/** Formats a local `Date` for an HTML `date` / `datetime-local` input value. */
export const toDateInputValue = (date: Date, type: DateInputType): string => {
  const ymd = `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
  if (type === 'date') {
    return ymd;
  }
  return `${ymd}T${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
};

/** Parses an HTML `date` / `datetime-local` input value into a local `Date`. */
export const fromDateInputValue = (
  raw: string,
  type: DateInputType,
): Date | null => {
  if (!raw) {
    return null;
  }
  if (type === 'date') {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
    if (!match) {
      return null;
    }
    const date = new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3]),
    );
    return Number.isNaN(date.getTime()) ? null : date;
  }
  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? null : date;
};
